export default "<p>join works!</p>\n";